module.exports = __webpack_public_path__ + "img/title4.e443c23a.png";